module.exports = __webpack_public_path__ + "static/media/22.3cc5d7c6.svg";